'use strict';

var React = require('react'),
    NavigationActionCreators = require('./actions/NavigationActionCreators'),
    NavigationContextTypes = require('./constants/NavigationContextTypes'),
    PageControlsActionCreators = require('./actions/PageControlsActionCreators'),
    PageControlsTypes = require('./constants/PageControlsTypes'),
    PlayerActionCreators = require('./actions/PlayerActionCreators'),
    getFirstAudioSection = require('./utils/getFirstAudioSection'),
    createSideEffect = require('react-side-effect'),
    { values } = require('underscore'),
    { PropTypes } = React;

var AppContext = createSideEffect(function (propsList) {
  var props = propsList[propsList.length - 1] || {};

  if (props.navigationContextType) {
    NavigationActionCreators.setContext(props.navigationContextType, props.navigationContextOptions);
  } else {
    NavigationActionCreators.clearContext();
  }

  if (props.pageControlsType) {
    PageControlsActionCreators.showPageControls(props.pageControlsType, props.pageControlsOptions);
  } else {
    PageControlsActionCreators.hidePageControls();
  }

  if (props.activeStamp) {
    const firstAudioSection = getFirstAudioSection(props.activeStamp);
    if (firstAudioSection) {
      PlayerActionCreators.considerSetStickyMedia(firstAudioSection.uuid);
    } else {
      PlayerActionCreators.considerRemoveStickyMedia();
    }
  } else {
    PlayerActionCreators.considerRemoveStickyMedia();
  }
}, {
	displayName: 'AppContext',

  propTypes: {
    navigationContextType: PropTypes.oneOf(values(NavigationContextTypes)),
    navigationContextOptions: PropTypes.object,
    pageControlsType: PropTypes.oneOf(values(PageControlsTypes)),
    pageControlsOptions: PropTypes.object,
    activeStamp: PropTypes.object
  }
});

module.exports = AppContext;


/** WEBPACK FOOTER **
 ** ./AppContext.jsx
 **/